import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error-message"
}
const _hoisted_2 = { class: "error-content" }
const _hoisted_3 = ["innerHTML"]

import { ref, computed, watch, onUnmounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'errorMessage',
  props: {
	text: {
		type: String,
		required: true
	}
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isVisible = ref(false);
let timeoutId: number | null = null;

const duration = computed(() => {
	// based on number of words : 32 words = 8 sec
	const calculatedDuration = props.text.trim().split(' ').length / 4 * 1000;
	return calculatedDuration > 5000 ? calculatedDuration : 5000;
});

const show = () => {
	isVisible.value = true;
	if (timeoutId) {
		clearTimeout(timeoutId);
	}
	timeoutId = window.setTimeout(() => {
		close();
	}, duration.value); // 
};

const close = () => {
	isVisible.value = false;
	if (timeoutId) {
		clearTimeout(timeoutId);
		timeoutId = null;
	}
	emit('close');
};

watch(() => props.text, (newText) => {
	if (newText) {
		show();
	} else {
		close();
	}
}, { immediate: true });

onUnmounted(() => {
	if (timeoutId) {
		clearTimeout(timeoutId);
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (isVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", { innerHTML: __props.text }, null, 8, _hoisted_3),
              _createElementVNode("button", {
                class: "close-button",
                onClick: close
              }, "×")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})